import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import { LoginService } from '../../shared/services/login.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private login: LoginService,
    private router: Router,
  ) {}

  canActivate(state: RouterStateSnapshot): boolean {
    if (this.login.isTokenValid()) {
      return true;
    } else {
      this.router.navigate(['/login'], {
        queryParams: { redirectUrl: state.url },
      });
      return false;
    }
  }
}
